export function WaveBrandHeader() {
  return (
    <div className="wave-brand-header">
      <span className="wave-brand-mark" aria-hidden>
        O
      </span>
      <span className="wave-brand-title">Oceany Wave</span>
    </div>
  );
}

function NavIcon({ name }: { name: "inbox" | "star" | "shared" | "board" }) {
  switch (name) {
    case "inbox":
      return (
        <svg viewBox="0 0 24 24" aria-hidden>
          <path d="M4 6h16v12H4V6zm2 2v8h12V8H6zm2 2h8l-4 3-4-3z" />
        </svg>
      );
    case "star":
      return (
        <svg viewBox="0 0 24 24" aria-hidden>
          <path d="M12 3.5l2.6 5.8 6.3.6-4.8 4.1 1.5 6.2L12 17.8 6.4 20.2l1.5-6.2-4.8-4.1 6.3-.6L12 3.5z" />
        </svg>
      );
    case "shared":
      return (
        <svg viewBox="0 0 24 24" aria-hidden>
          <path d="M16 11a3 3 0 1 0-2.8-4H11a4 4 0 1 0 0 8h2.2A3 3 0 0 0 16 11zm-7 1a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm9 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-9 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
        </svg>
      );
    case "board":
      return (
        <svg viewBox="0 0 24 24" aria-hidden>
          <path d="M5 5h5v14H5V5zm9 0h5v8h-5V5zm0 10h5v4h-5v-4z" />
        </svg>
      );
  }
}

export function WaveSidebarNavIcon({ name }: { name: "inbox" | "star" | "shared" | "board" }) {
  return (
    <span className="wave-sidebar-nav-icon">
      <NavIcon name={name} />
    </span>
  );
}

export function WaveFavoriteButton({
  active,
  onToggle,
  label,
  className = "",
}: {
  active: boolean;
  onToggle: () => void;
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      className={`wave-favorite-btn${active ? " active" : ""}${className ? ` ${className}` : ""}`}
      aria-label={label}
      aria-pressed={active}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      {active ? "★" : "☆"}
    </button>
  );
}
